import { useCallback, useState } from 'react';
import { getRiderBySlug, getRideSchedule } from '@rideiq/api/services/Riders';
import { useQuery } from '@tanstack/react-query';

export const RIDER_QUERY_KEY = 'rider';
export const RIDE_SCHEDULE_QUERY_KEY = 'rideSchedule';

export const useRiderQuery = () => {
  const [slug, setSlug] = useState<string | null>(null);

  const riderQuery = useQuery({
    queryKey: [RIDER_QUERY_KEY, slug],
    queryFn: async () => {
      const response = await getRiderBySlug(slug!);

      if (response.type === 'error') {
        throw new Error(response.error.errors[0] ?? 'Failed to load rider');
      }

      return response.data.passenger;
    },
    enabled: !!slug,
  });

  const scheduleQuery = useQuery({
    queryKey: [RIDE_SCHEDULE_QUERY_KEY, slug],
    queryFn: async () => {
      const response = await getRideSchedule(slug!);

      if (response.type === 'error') {
        throw new Error(response.error.errors[0] ?? 'Failed to load schedule');
      }

      return response.data;
    },
    enabled: !!slug,
  });

  const fetchRiderBySlug = useCallback((passengerSlug: string) => {
    setSlug(passengerSlug);
  }, []);

  const fetchRideSchedule = useCallback((passengerSlug: string) => {
    setSlug(passengerSlug);
  }, []);

  return {
    slug,
    riderDetails: riderQuery.data,
    riderContacts: riderQuery.data?.passengersContacts ?? [],
    rideSchedule: scheduleQuery.data,
    isFetchingRider: riderQuery.isFetching,
    isFetchingSchedule: scheduleQuery.isFetching,
    isErrorRider: riderQuery.isError,
    refetchRider: riderQuery.refetch,
    fetchRiderBySlug,
    fetchRideSchedule,
  };
};
